package com.crowpay.views.components

import com.crowpay.Resources
import com.crowpay.activity
import com.crowpay.circle
import com.crowpay.threeGears
import com.crowpay.utils.existsDefaultFalse
import com.crowpay.utils.resize
import com.crowpay.views.screens.common.ActionImportance
import com.crowpay.views.theming.AppColors
import com.crowpay.views.theming.DisplayableStateSemantic
import com.crowpay.views.theming.Unread
import com.crowpay.views.theming.body
import com.crowpay.views.theming.colored
import com.lightningkite.kiteui.models.Dimension
import com.lightningkite.kiteui.models.Icon
import com.lightningkite.kiteui.models.PopoverPreferredDirection
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.reactive.ReactiveContext
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.views.ViewDsl
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.dynamicTheme
import com.lightningkite.kiteui.views.l2.icon

@ViewDsl
fun ViewWriter.infoBubble(popover: PopoverPreferredDirection, message: String) =
    hintPopover(popover) {
        sizeConstraints(maxWidth = 25.rem) - body(message)
    } - icon {
        description = "Additional Information"
        source = Icon.info.copy(width = 1.rem, height = 1.rem)
    }

@ViewDsl
fun ViewWriter.infoBubble(message: String) = infoBubble(PopoverPreferredDirection.aboveRight, message)

@ViewDsl
fun ViewWriter.activityIcon() = colored(AppColors.yellow.main) - icon(Icon.activity, "Activity")

@ViewDsl
fun ViewWriter.activityIcon(setup: IconView.()->Unit) = colored(AppColors.yellow.main) - icon {
    setup()
    source = Icon.activity
}

@ViewDsl
fun ViewWriter.unreadIcon(setup: IconView.() -> Unit = {}) = Unread.onNext - icon {
    description = "unread"
    setup()
    source = Icon.circle
}

fun ViewWriter.unreadIconWhen(shown: ReactiveContext.() -> Boolean) = unreadIcon { existsDefaultFalse(shown) }

fun ViewWriter.unreadIconVisible(shown: ReactiveContext.() -> Boolean) = unreadIcon {
    visible = false
    ::visible.invoke(shown)
}

fun ViewWriter.actionIcon(shown: ReactiveContext.() -> ActionImportance?) = icon {
    existsDefaultFalse { shown() != null }
    dynamicTheme { shown()?.let(::DisplayableStateSemantic) }
    ::description { shown()?.displayName ?: "" }
    ::source { shown()?.icon }
}

fun ViewWriter.scopeSetIcon(size: Dimension? = null, setup: IconView.() -> Unit = {}) = colored(AppColors.secondary.main) - icon {
    setup()
    source = Icon.threeGears.let { if (size != null) it.resize(size) else it }
    description = "Worked Together"
}